import BorderCard from "@/features/campaigns/components/UserCampaigns/components/BorderCard";
import React from "react";

const ActivityCard = ({ title, children }) => {
  return (
    <div className="flex flex-col gap-0 h-full">
      <BorderCard variant="top" padding="p-4">
        <h5 className="text-xs font-semibold text-gray-700 dark:text-gray-200 font-[Inter]">
          {title}
        </h5>
      </BorderCard>
      <BorderCard
        variant="bottom"
        className="flex-1 flex-col overflow-y-auto max-h-[245px]"
        padding="p-4"
      >
        {children}
      </BorderCard>
    </div>
  );
};

export default ActivityCard;
